export default __webpack_public_path__ + "static/media/error-tramo.de6bfe7f.svg";